import Icon from 'vue-awesome/components/Icon'

Icon.register({
  fast_rewind_rounded: {
    paths: [
      {
        d: 'M11 16.07V7.93c0-.81-.91-1.28-1.58-.82l-5.77 4.07c-.56.4-.56 1.24 0 1.63l5.77 4.07c.67.47 1.58 0 1.58-.81zm1.66-3.25l5.77 4.07c.66.47 1.58-.01 1.58-.82V7.93c0-.81-.91-1.28-1.58-.82l-5.77 4.07a1 1 0 000 1.64z'
      }
    ],
    width: '24',
    height: '24'
  }
})
